<!-- 个人中心 -->
<template>
  <div class="mine">
    <div class="header-bg"></div>
    <div class="header">
      <user-card class="usercard" />
    </div>
    
    <div class="mine-list">
      <ul class="list-box">
        <li class="list-item order" @click="goOrderlist">
          <img class="item-icon" src="@/assets/mine/order.png">
          <span class="text">我的订单</span>
          <img class="right-arrow-icon" src="@/assets/global/arrow_right.png">
        </li>
        <li class="list-item download" @click="goDownload">
          <img class="item-icon" src="@/assets/mine/download.png">
          <span class="text">下载口袋故事APP</span>
          <img class="right-arrow-icon" src="@/assets/global/arrow_right.png">
        </li>
      </ul>
    </div>

    <a class="btn context" href="tel:4008255211">联系客服：400-825-5211</a>
    <a class="btn goindex" :href="indexPage">回到首页</a>
  </div>
</template>

<script>
import UserCard from '@/components/UserCard/index'
import config from '@/config/config'

export default {
  components: { UserCard },
  data () {
    return {
      indexPage: config.indexPage,
    }
  },
  created () {
    
  },
  methods: {
    goOrderlist() {
      this.$router.push({ path: 'orderlist' })
    },
    goDownload() {
      window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.appshare.android.ilisten&ckey=CK1321531259444'
    },
  },
}
</script>

<style scoped lang="less">
  @import "~@/styles/fn";
  .mine {
    position: relative;
    padding-top: .4rem;
    padding-bottom: 1.8rem;
  }
  .header-bg {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 2.8rem;
    .bg("~@/assets/buyvip/header-bg.png");
  }
  .header {
    margin-bottom: .48rem;
  }
  .mine-list {
    margin-bottom: .64rem;
    padding: 0 .32rem;
    user-select: none;
  }
  .list-item {
    display: flex;
    align-items: center;
    height: 1.2rem;
    border-bottom: 1px solid rgba(0,0,0,.1);
    .item-icon {
      display: block;
      width: .56rem;
      height: .56rem;
    }
    .text {
      flex: 1;
      padding: 0 .24rem;
      font-size: .34rem;
      color: #6c6c73;
    }
    .right-arrow-icon {
      display: block;
      width: .16rem;
    }
  }
  .btn {
    margin: 0 auto;
    width: 5.9rem;
    height: 1.12rem;
    background: #fedc42;
    font-size: .34rem;
    color: #604038;
    font-weight: bold;
  }
  .goindex {
    margin-top: .38rem;
  }
</style>
